var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-visual"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "visual-img",
    attrs: {
      "src": "/images/main/visual01.jpg",
      "alt": ""
    }
  }), _c('v-container', {
    staticClass: "white--text"
  }, [_c('h2', {
    staticClass: "tit tit--xl mb-24"
  }, [_vm._v("GOOD MOOD FOOD, MO DOO!")]), _c('p', {
    staticClass: "page-text page-text--lg font-weight-medium"
  }, [_vm._v(" 신선한 재료 엄선, 건강한 식자재 공급."), _c('br'), _vm._v(" 식자재 유통의 모두! 최대한 모든 식자재를 다양한 방법으로 유통합니다. ")]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-pagination"
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "visual-img",
    attrs: {
      "src": "/images/main/visual02.jpg",
      "alt": ""
    }
  }), _c('v-container', {
    staticClass: "white--text"
  }, [_c('h2', {
    staticClass: "tit tit--xl mb-24"
  }, [_vm._v("One stop shopping!")]), _c('p', {
    staticClass: "page-text page-text--lg font-weight-medium"
  }, [_vm._v(" 식자재 전제품 세팅을 한번에! All in one!"), _c('br'), _vm._v(" 2000여가지의 다수 제품 보유, 가격의 차별화와 경쟁력을 가지고 있습니다. ")]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-pagination"
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "visual-img",
    attrs: {
      "src": "/images/main/visual03.jpg",
      "alt": ""
    }
  }), _c('v-container', {
    staticClass: "white--text"
  }, [_c('h2', {
    staticClass: "tit tit--xl mb-24"
  }, [_vm._v("Every food&total services")]), _c('p', {
    staticClass: "page-text page-text--lg font-weight-medium"
  }, [_vm._v(" 소상공인부터 프랜차이즈 또는 레스토랑 그리고 요식업계열 대기업까지 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 26년간의 노하우로 좋은 품질의 제품을 보다 빠르게 공급합니다. ")]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-pagination"
  })])])], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }